import React, {Component} from 'react'
import Elm from 'react-elm-components'
import MyComp from '../../../elm/src/QualificationCriteriaTicketAnswers.elm'
import config from '../../config'

class QualificationCriteriaAnswers extends Component {

    setupPorts = (ports) => {
        const {onChange} = this.props
        ports.qualifyTicketUpdate.subscribe((qualification) => {
            onChange(qualification)
        })
    }

    render() {
        const {clientCompany, otp, qualification} = this.props
        const {choices} = qualification || {}

        if (!clientCompany || !otp) {
            return <div></div>
        }

        return (
            <div>
                <Elm src={MyComp.Elm.QualificationCriteriaTicketAnswers}
                     flags={{apiUrl: config.api.url, otp, clientCompany, choices: choices || []}}
                     ports={this.setupPorts}
                />
            </div>
        )
    }
}

export default QualificationCriteriaAnswers


// WEBPACK FOOTER //
// ./lib/ticket/components/QualificationCriteriaAnswers.js